import React from 'react'
import { Dialog } from '@atd/rui-base.mui.dialog'
import useMediaQuery from '@mui/material/useMediaQuery'

export default function ResponsiveDialog(props) {
    const fullScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

    return <Dialog fullScreen={fullScreen} {...props} />
}
